import { useParams, Navigate } from "react-router-dom";
import { useRole, canSeeModule, canSeeSubscreen } from "../lib/role.tsx";
import { MODULES } from "../lib/modules.js";
import { ModuleShell } from "./ModuleShell.js";

interface RequireModuleAccessProps {
  slug?: string;
}

export function RequireModuleAccess({ slug: slugProp }: RequireModuleAccessProps = {}) {
  const params = useParams<{ slug?: string; "*": string }>();
  const slug = slugProp ?? params.slug;
  const subPath = params["*"] ?? "";
  const role = useRole();

  const mod = MODULES.find((m) => m.slug === slug);

  if (!mod) {
    console.warn(`[RequireModuleAccess] Module "${slug}" not found in MODULES`);
    return <Navigate to="/" replace />;
  }

  if (!canSeeModule(role, mod)) {
    console.warn(`[RequireModuleAccess] Role "${role}" cannot access module "${slug}"`);
    return <Navigate to="/" replace />;
  }

  if (mod.subscreens && mod.subscreens.length > 0) {
    const currentSubSlug = (subPath ?? "").split("/")[0];

    if (!currentSubSlug) {
      const firstAccessible = mod.subscreens.find((s) => canSeeSubscreen(role, s));
      if (firstAccessible) {
        return <Navigate to={`/m/${slug}/${firstAccessible.slug}`} replace />;
      }
      return <Navigate to="/" replace />;
    }

    const currentSub = mod.subscreens.find((s) => s.slug === currentSubSlug);
    if (!currentSub || !canSeeSubscreen(role, currentSub)) {
      const firstAccessible = mod.subscreens.find((s) => canSeeSubscreen(role, s));
      if (firstAccessible) {
        return <Navigate to={`/m/${slug}/${firstAccessible.slug}`} replace />;
      }
      return <Navigate to="/" replace />;
    }
  }

  return <ModuleShell title={mod.label} />;
}
